import { l } from '@manychat/manyui'

import { UpgradeSource } from 'common/billing'
import { handleGoProError } from 'common/billing/helpers/handleGoProError'
import { alert } from 'common/core'
import * as API from 'constants/API'
import { anotherTabNotificationsListener } from 'utils/services/notificationsService'

import * as atypes from '../zapierReduxActionTypes'

export const fetchZaps = () => {
  return (dispatch, getState) => {
    const { zaps } = getState()

    if (zaps.items === null && !zaps.fetching) {
      dispatch({
        type: atypes.ZAPS_FETCH,
        $fetch: API.fetchZaps,
      })
    }
  }
}

export const zapCreatedNotification = (zap) => ({
  type: atypes.ZAP_CREATED_NOTIFICATION,
  zap,
})

export const zapRemovedNotification = (eventId) => ({
  type: atypes.ZAP_REMOVED_NOTIFICATION,
  eventId,
})

export const createZap = (event_name, requestId) => {
  return (dispatch, getState) => {
    dispatch({
      type: atypes.ZAPS_CREATE,
      $fetch: API.createZap.replace(':event_name', event_name),
      $success: () => alert(l.translate('Event Created!'), 'success'),
      $error: (err) => {
        if (err.go_pro) {
          const max = getState().zaps.items.length
          const message = l.translate(
            "You've reached the limit of events ({max}/{max}) on the current plan. Upgrade for unlimited access.",
            { max },
          )

          dispatch(
            handleGoProError(err, {
              message,
              source: UpgradeSource.ZAPIER,
              modalTitle: l.translate('Create unlimited events with Manychat Pro'),
              products: err.products,
            }),
          )
        } else {
          alert(err, 'danger')
        }
      },
      event_name,
      requestId: requestId || Date.now(),
    })
  }
}

anotherTabNotificationsListener.on('zapier_event_created', (data, dispatch) => {
  dispatch(zapCreatedNotification(data.model))
})
